import { TFunction } from 'i18next'

import { InvoiceDocumentType } from '../enums/invoiceDocumentType'
import { SendAsEmailModalVariant } from '../enums/sendAsEmailModalVariant'
import { ZervantLocale } from '../enums/zervantLocale'
import { getInvoiceDocumentTitle } from './getInvoiceDocumentTitle'

interface GetDocumentNameOptions {
  documentLocale?: ZervantLocale
  documentType: InvoiceDocumentType
  invoiceNumber?: string | null
  organizationName?: string
  paymentReminderEmailSubjectTemplate?: string
  t: TFunction
  variant?: SendAsEmailModalVariant
}

export const getDocumentName = ({
  documentLocale,
  documentType,
  invoiceNumber,
  organizationName,
  paymentReminderEmailSubjectTemplate,
  t,
  variant,
}: GetDocumentNameOptions) => {
  let name = getInvoiceDocumentTitle({ documentType, language: documentLocale || ZervantLocale.EN_GB, t }).toUpperCase()

  if (invoiceNumber) {
    name += ` ${invoiceNumber.toUpperCase()}`
  }

  if (organizationName) {
    name += ` - ${organizationName}`
  }

  if (variant && variant === SendAsEmailModalVariant.Reminder) {
    name = `${paymentReminderEmailSubjectTemplate} - ${name}`
  }

  return name
}
